import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const documentsTableTooltips = TOOLTIPS_TEXTS.documentsTable;

export const BASE_DOCUMENTS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'download', src: 'icons/download-green' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_DOCUMENTS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_DOCUMENTS_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'name',
    'description',
    'fileSize',
    'phases',
    'divisions',
    'communities',
    'options'
  ],
  displayedTitles: [
    'Name',
    'Description',
    'File Size',
    'Phase(s)',
    'Division(s)',
    'Assigned Communities',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false }
  ],
  displayedTooltips: [
    documentsTableTooltips.name,
    documentsTableTooltips.description,
    documentsTableTooltips.fileSize,
    documentsTableTooltips.phases,
    documentsTableTooltips.divisions,
    documentsTableTooltips.communities
  ],
  options: null,
  dataSource: []
};
